// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2mVlG","errorLogs":"EditorFooter_errorLogs__2o2d_"};